import { db } from '../utils/configureFirebase';

export const getIssueTracks = (cb) => {
  const unsubscribe = db.collection('issueTrack').onSnapshot((snapshot) => {
    const issueTrack = [];
    snapshot.forEach((doc) => {
      issueTrack.push(doc.data());
    });
    cb(issueTrack);
  });
  return unsubscribe;
};



// WEBPACK FOOTER //
// ./src/services/issueTrackServices.js